/**
* DevExpress Analytics (query-builder\dataSource\sql\customSqlQuery.js)
* Version:  21.2.13
* Build date: Apr 10, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ko = require("knockout");
var utils_1 = require("../utils");
var serializer_1 = require("../../../serializer/serializer");
var utils_2 = require("../../../serializer/utils");
var dataSourceParameter_1 = require("../dataSourceParameter");
var customSqlQueryMeta_1 = require("./customSqlQueryMeta");
var _utils_1 = require("../../../serializer/_utils");
var CustomSqlQuery = (function () {
    function CustomSqlQuery(model, parent, serializer) {
        this.parent = parent;
        (serializer || new serializer_1.ModelSerializer()).deserialize(this, _utils_1.extend(model, { '@ItemType': 'Query' }));
        this.type = ko.pureComputed(function () { return utils_1.SqlQueryType.customSqlQuery; });
        this.parameters = utils_2.deserializeArray(model['Parameters'], function (item) {
            return new dataSourceParameter_1.DataSourceParameter(item, serializer);
        });
    }
    CustomSqlQuery.prototype.getInfo = function () {
        return customSqlQueryMeta_1.customQuerySerializationsInfo;
    };
    CustomSqlQuery.prototype.generateName = function () {
        return 'CustomSqlQuery';
    };
    return CustomSqlQuery;
}());
exports.CustomSqlQuery = CustomSqlQuery;
